import script from "./TableMobileSort.vue?vue&type=script&setup=true&lang=js"
export * from "./TableMobileSort.vue?vue&type=script&setup=true&lang=js"

import "./TableMobileSort.vue?vue&type=style&index=0&id=3806b4b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3806b4b2"]])

export default __exports__